import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import AppBar from "../components/app-bar";
import Dashboard from "../pages/dashboard";
import SoloStudy from "../pages/solo-study";
import GroupStudy from "../pages/group-study";
import Explore from "../pages/explore";
import Profile from "../pages/profile";
import Settings from "../pages/settings";
import Landing from "../pages/landing";

const Routes = () => {
  const loggedIn = useSelector((state) => state.userPreferences.loggedIn);

  const LoggedInRoutes = () => (
    <Router>
      <Switch>
        <Route
          path="/:page?"
          component={() => (
            <AppBar>
              <Switch>
                <Route path="/redirect" component={Dashboard} />
                <Route exact path="/" component={Dashboard} />
                <Route path="/solo-study" component={SoloStudy} />
                <Route path="/group-study" component={GroupStudy} />
                <Route path="/explore" component={Explore} />
                <Route path="/profile/:username?" component={Profile} />
                <Route path="/settings/:notifications?" component={Settings} />
              </Switch>
            </AppBar>
          )}
        />
      </Switch>
    </Router>
  );

  const LoggedOutRoutes = () => (
    <Router>
      <Switch>
        <Route path="/redirect" component={Landing} />
        <Route exact path="/" component={Landing} />
        <Route
          path="/:page?"
          component={() => (
            <AppBar>
              <Switch>
                <Route path="/dashboard" component={Dashboard} />
                <Route path="/solo-study" component={SoloStudy} />
                <Route path="/group-study" component={GroupStudy} />
                <Route path="/explore" component={Explore} />
              </Switch>
            </AppBar>
          )}
        />
      </Switch>
    </Router>
  );

  return loggedIn ? <LoggedInRoutes /> : <LoggedOutRoutes />;
};

export default Routes;
